import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LorenNotificationDetailsComponent} from './components/loren-notification-details/loren-notification-details.component';
import {LorenNotificationResolverConstant} from './resolvers/constants/loren-notification-resolver.constants';
import {LorenNotificationResolver} from './resolvers/loren-notification.resolver';
import {LOREN_ROUTES} from '../../shared/constants/loren-routes.constants';

const routes: Routes = [
    {
        path: `:${LorenNotificationResolverConstant.NOTIFICATION}/${LOREN_ROUTES.DETAILS}`,
        resolve: {
            notification: LorenNotificationResolver
        },
        component: LorenNotificationDetailsComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LorenNotificationRoutingModule {
}
